var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.9302H13L8.54999 21.8902C7.88999 22.3302 7 21.8602 7 21.0602V18.9302C4 18.9302 2 16.9302 2 13.9302V7.93018C2 4.93018 4 2.93018 7 2.93018H17C20 2.93018 22 4.93018 22 7.93018V13.9302C22 16.9302 20 18.9302 17 18.9302Z",
    stroke: "#171717",
    strokeWidth: 2.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 11.8599V11.6499C12.0003 10.9699 12.4203 10.6099 12.8403 10.3199C13.2503 10.0399 13.6603 9.6799 13.6603 9.0199C13.6603 8.0999 12.9203 7.35986 12.0003 7.35986C11.0803 7.35986 10.3403 8.0999 10.3403 9.0199",
    stroke: "#171717",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9955 14.25H12.0045",
    stroke: "#171717",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.42421db2dd0035340ffef4760a22f0e7.svg";
export { ForwardRef as ReactComponent };